export default function AuthSubmitBar({ children }) {
	return (
		<div className="-mx-4 sm:-mx-5 -mb-4 sm:-mb-5 mt-2 border-t border-[#E2E8F0]">
			<div className="w-full h-[56px] sm:h-[58px]">{children}</div>
		</div>
	);
}
